
export default {
	name: 'e-bill-muti-applied',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption', 'applyText'],
	data() {
		return {
			cancelPath:'',
			cancelText:'',
		};
	},
	computed: {},
	watch: {},
	created() {
	},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		init(){
			if(this.applyOption == 'eBill'){
				this.cancelPath = '/eBill/SMS/eBillCancel'
				this.cancelText = '簡訊'
			}else if(this.applyOption == 'SMS'){
				this.cancelPath = '/eBill/eBill/eBillCancel'
				this.cancelText = '電子'
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillCancel/eBillMutiApplied.js